<div class="confirm-driveplus-dialog">
  <div class="confirm-driveplus-dialog__header">
    {{ "plans.motorMembership.dialogHeader" | translate }}
    <mat-icon mat-dialog-close>cancel</mat-icon>
  </div>
  <div 
    class="confirm-driveplus-dialog__content"
    [innerHTML]="'plans.motorMembership.dialogContent' | translate: {
      discountPercentage: data.discountPercentage
    }"
  ></div>
  <div class="confirm-driveplus-dialog__footer">
    <button mat-stroked-button class="btn--stroke" (click)="cancelDriveplus()">
      {{ "plans.motorMembership.cancel" | translate }}
    </button>
    <button mat-flat-button mat-dialog-close class="btn--fill" (click)="triggerToggle()">
      {{ "plans.motorMembership.join" | translate }}
    </button>
  </div>
</div>